export default (): boolean => /iPad|iPhone|iPod|Mac/.test(navigator.userAgent);
